export default "__VITE_ASSET__Cug71B8p__"